// extracted by css-extract-rspack-plugin
export default {"emptyStateContainer":"EmptyState_emptyStateContainer__bXPKq"};